"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PersonalEventType = void 0;
var PersonalEventType;
(function (PersonalEventType) {
    PersonalEventType["LOGIN_SUCCESSFUL"] = "LOGIN_SUCCESSFUL";
    PersonalEventType["LOGIN_FAILED"] = "LOGIN_FAILED";
    PersonalEventType["LOGOUT"] = "LOGOUT";
    PersonalEventType["LOGOUT_AUTOMATIC"] = "LOGOUT_AUTOMATIC";
})(PersonalEventType = exports.PersonalEventType || (exports.PersonalEventType = {}));
//# sourceMappingURL=personal-events-types.js.map